import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { OVERVIEWS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/overviews/$id")({
  component: () => <DeptContentForm cfg={OVERVIEWS} id={Route.useParams().id} />,
});
